import React from 'react';
import { ArrowLeft } from 'lucide-react';
import EmployeeForm from './EmployeeForm';

export default function EmployeeFormModal({ employee, departments, onSave, onCancel }) {
  return (
    <div className="space-y-4">

      {/* ── Back button ──────────────────────────────────────────── */}
      <div className="flex items-center gap-3">
        <button
          onClick={onCancel}
          className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-800 transition-colors"
        >
          <ArrowLeft size={16} />
          {employee ? 'Volver' : 'Volver a Empleados'}
        </button>
      </div>

      {/* ── Page title card ───────────────────────────────────────── */}
      <div className="bg-white border border-gray-200 rounded-xl px-6 py-4">
        <h2 className="text-lg font-bold text-gray-900">
          {employee ? 'Editar Empleado' : 'Nuevo Empleado'}
        </h2>
        {employee && (
          <p className="text-sm text-gray-400 mt-0.5">
            {employee.nombre} {employee.apellido}
          </p>
        )}
      </div>

      {/* ── Form ─────────────────────────────────────────────────── */}
      <div className="bg-white border border-gray-200 rounded-xl p-6">
        <EmployeeForm
          employee={employee}
          departments={departments}
          onSave={onSave}
          onCancel={onCancel}
        />
      </div>

    </div>
  );
}
